var yy_request = require('./js/yunyin_request')
    var po = require('./js/public_object.js')

    module.exports = {
        el: '#app',

        data: function() {
            return {
                view: '',
                showLoginModal: false,
                showFileTaskModal: false,
                showInfoModal: false,
                showSlideMenu: false,
                fileTaskParams: {
                    mode: 'newfile',
                    fileList: [],
                    taskinfo: {},
                },
                infoModalText: '',
                mySelectOptions: [{
                    value: 1,
                    display: "这个打印店还不错哦"
                }, {
                    value: 2,
                    display: "超级无敌打印店2"
                }, ],
                mySelectValue: null,
                username: null,
                showSpinner: false,
                showNetworkHint: false,
            }
        },

        methods: {
            onUploadFile: function() {
                if (po.islogin) {
                    this.fileTaskParams = {
                        mode: 'newfile',
                        fileList: [],
                        taskinfo: {},
                    }
                    this.showFileTaskModal = true
                } else {
                    this.showLoginModal = true
                }
            },

            onClickLogin: function() {
                if (this.username == null) {
                    this.showLoginModal = true
                } else {
                    window.location.hash = "#/user"
                }
            },

            onFileChange: function() {
                if (window.location.hash == "#/file") {
                    po.vueFileList.onFileChange()
                } else {
                    window.location.hash = "#/file"
                }
            },

            onTaskChange: function() {
                if (window.location.hash == "#/task") {
                    po.vueTaskList.onTaskChange()
                } else {
                    window.location.hash = "#/task"
                }
            },

            onLogout: function() {
                yy_request.rest_api({
                    method: 'get',
                    api: 'auth/logout',
                    opSuccess: function(info) {
                        po.islogin = false
                        po.app.username = null
                        window.location.hash = "#/home"
                        po.app.showLoginModal = true
                    },
                })
            },
        },

        compiled: function() {
            if (po.islogin) {
                this.username = po.userinfo.name
            } else {
                this.username = null
            }
        },

        components: {
            'intro-view': require('./views/intro-view.vue'),
            'menu-view': require('./views/menu-view.vue'),
            'task-view': require('./views/task-view.vue'),
            'file-view': require('./views/file-view.vue'),
            'myshare-view': require('./views/myshare-view.vue'),
            'share-view': require('./views/share-view.vue'),
            'book-view': require('./views/book-view.vue'),
            'user-view': require('./views/user-view.vue'),
            'printer-view': require('./views/printer-view.vue'),
            'forget-view': require('./views/forget-view.vue'),
            'login-modal': require('./components/login-modal.vue'),
            'filetask-modal': require('./components/filetask-modal.vue'),
            'info-modal': require('./components/info-modal.vue'),
        }
    }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/app.vue
// module id = 135
// module chunks = 0